import type { ThemeMode, ResolvedTheme } from './theme.types'

/**
 * Pure, side-effect-free theme resolver.
 * Returns the concrete color scheme from the user's explicit in-app preference.
 * The OS setting is tracked for diagnostics/future affordances, but does not
 * decide the default app theme.
 */
export function resolveTheme(mode: ThemeMode, _systemTheme: ResolvedTheme): ResolvedTheme {
  return mode
}
